<template>
    <div v-if="notificationData.type === 'danger-popup' && show"
        class="absolute w-full h-dvh z-[1000] bg-black/25 flex justify-center items-center p-8">
        <div class="w-full max-w-96 max-h-4/5 h-auto bg-white rounded-2xl shadow p-5 text-justify relative animation_up">
            <div @click="closePopup" class="absolute z-10 w-max h-auto top-5 right-5 cursor-pointer">
                <Icon name="close" class="w-4 h-4" />
            </div>
            <img src="@/assets/images/Thinking-face-rafiki.png" alt="no-1.png" class="object-contain w-full max-w-72 mx-auto" tabindex="-1">
            <strong>{{notificationData.title}}</strong>
            <p class="text-gray-600 text-sm">
                {{ notificationData.message }}
            </p>
        </div>
    </div>
    <div v-else-if="show" :class="{ 'notification-header dark:!bg-gray-700 dark:!text-gray-50': true, show: show }">
        <div class="notification-content">
            <div class="notification-text">
                <strong>{{ notificationData.title }}</strong>
                <div class="dark:!text-gray-50" :class="{
                    'text-red-600': notificationData.type === 'danger',
                    'text-green-600': notificationData.type === 'success',
                    'text-sky-600': notificationData.type === 'info',
                    'text-amber-600': notificationData.type === 'warning'
                }" v-html="notificationData.message"></div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/libs/eventBus';
import Icon from './Icon.vue'

export default {
    components: {
        Icon
    },
    data() {
        return {
            show: false,
            notificationData: {
                id: '',
                title: '',
                message: '',
                url: '',
                type: 'danger'
            }
        };
    },
    created() {
        // Lắng nghe sự kiện 'show-notification' từ EventBus
        EventBus.on('show-notification', this.showNotification);
    },
    methods: {
        showNotification(jsonString) {
            console.log('showNotification called with:', jsonString);

            // Kiểm tra nếu thông báo đang hiển thị thì không làm gì thêm
            if (this.show) {
                console.log('Notification is already showing, ignoring new notification.');
                return;
            }

            try {
                const data = JSON.parse(jsonString);
                console.log('Parsed data:', data);
                let time_out = 2000;
                if ('showtime' in data) {
                    time_out = data.showtime;
                }
                this.notificationData = data;
                this.show = true;

                // Đặt thời gian ẩn sau 5 giây cho cac thong bao thuong
                if (this.notificationData.type !== 'danger-popup') {
                    setTimeout(() => {
                        this.show = false;
                    }, time_out);
                }
            } catch (error) {
                console.error('Invalid JSON string:', error);
            }
        },
        closePopup() {
            this.show = false;
        }
    },
    beforeUnmount() {
        // Hủy bỏ lắng nghe sự kiện khi component bị destroy
        EventBus.off('show-notification', this.showNotification);
    }
};
</script>

<style scoped>
.notification-header {
    position: fixed;
    top: -100px;
    /* Bắt đầu ngoài màn hình */
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 600px;
    background-color: #ececec;
    color: black;
    padding: 10px 20px;
    border-radius: 8px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    text-align: left;
    z-index: 1002;
    transition: top 0.3s ease-in-out, box-shadow 1s ease, background-color 1s ease;
    animation: fadeInBackground 1s ease forwards;
}

.notification-header.show {
    top: 2px;
    box-shadow: 0px 8px 20px rgba(0, 0, 0, 0.3);
}

.notification-content {
    display: flex;
    align-items: center;
}

.notification-text strong {
    font-size: 16px;
    display: block;
    margin-bottom: 5px;
}

.notification-text div {
    font-size: 14px;
}

/* Responsive styles for small screens */
@media (max-width: 480px) {
    .notification-header {
        width: 95%;
        max-width: 90%;
        padding: 8px 16px;
        font-size: 14px;
    }

    .notification-text strong {
        font-size: 14px;
    }

    .notification-text div {
        font-size: 12px;
    }
}

/* Animation to fade in the background color */
@keyframes fadeInBackground {
    0% {
        background-color: #ececec;
        color: black;
    }

    100% {
        background-color: #ffffff;
        color: black;
    }
}

</style>
